import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Input, Label } from "semantic-ui-react";

function isInt(value) {
    var x;
    if (isNaN(value)) {
        return false;
    }
    x = parseFloat(value);
    return (x | 0) === x;
}

export default connect(mapStateToProps)(
    class InputBox extends Component {
        static propTypes = {
            action: PropTypes.func.isRequired,
            target: PropTypes.string.isRequired,
            init: PropTypes.number.isRequired,
        };

        constructor(props) {
            super(props);
            this.state = {
                value: props.init,
                isError: false,
            };
        }

        onChange = (e) => {
            if (e.target.value === "") {
                this.setState({ value: "" });
                return undefined;
            }

            if (e.target.value.length > this.state.value.toLocaleString(this.props.language).length) {
                let test = e.target.value.replace(this.state.value.toLocaleString(this.props.language), "");

                if ((!isInt(test) && test !== "," && test !== ".") || (this.props.integer && !isInt(e.target.value))) {
                    this.setState({ value: e.target.value, isError: true });
                    return undefined;
                }
            }

            let val =
                this.props.language === "fr"
                    ? parseFloat(e.target.value.replace(/\s/g, "").replace(/,/g, "."))
                    : parseFloat(e.target.value.replace(/\s/g, "").replace(/,/g, ""));

            if ((this.props.min || this.props.max) && (val >= this.props.max || val <= this.props.min)) {
                this.setState({ isError: true, value: e.target.value });
            } else {
                this.setState({ isError: false, value: e.target.value });
                this.props.action(this.props.target, val);
                if (!!this.props.secondaryAction) {
                    this.props.secondaryAction(this.props.target, val);
                }
            }
        };

        componentWillReceiveProps(nextProps) {
            this.setState({ value: nextProps.init });
        }

        render() {
            return (
                <Input
                    type="text"
                    labelPosition="right"
                    error={this.state.isError}
                    value={this.state.value ? this.state.value.toLocaleString(this.props.language) : ""}
                    onChange={this.onChange.bind(this)}
                    disabled={this.props.disabled}
                    fluid={this.props.fluid}
                    step={this.props.step}>
                    {this.props.label ? (
                        <Label
                            style={{
                                width: "50%",
                                borderRadius: "5px 0px 0px 5px",
                                borderColor: "black",
                                borderWidth: "1px 0px 1px 1px",
                            }}>
                            {this.props.label}
                        </Label>
                    ) : null}
                    <input style={{ borderColor: "black" }} />
                    {this.props.suffix ? (
                        <Label style={{ width: "20%", borderColor: "black" }} basic>
                            {this.props.suffix}
                        </Label>
                    ) : null}
                </Input>
            );
        }
    }
);

function mapStateToProps(state) {
    return {
        language: state.reducerLanguage,
    };
}



// WEBPACK FOOTER //
// ./src/components/inputbox.js